// eslint-disable-next-line no-restricted-imports
import {TypedUseSelectorHook, useDispatch, useSelector, useStore} from 'react-redux';

import {AppState} from '../store/appState';
import {AppStore} from '../store/appStore';

export const useAppDispatch = () => useDispatch<AppStore['dispatch']>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

/** Prefer using `useAppDispatch` and `useAppSelector` as much as possible. */
export const useAppStore = (): AppStore => useStore();
